import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from 'recharts';
const chartData = [{
  name: 'Faster decisions',
  value: 25,
  color: '#2563eb'
}, {
  name: 'Higher throughput',
  value: 25,
  color: '#10b981'
}, {
  name: 'Consistency',
  value: 25,
  color: '#f59e0b'
}, {
  name: 'Scalable foundations',
  value: 25,
  color: '#ef4444'
}];
const aiSkills = [{
  label: 'Intake & Triage',
  description: 'intent detection, routing, summarization'
}, {
  label: 'Research & Enrichment',
  description: 'web/data retrieval, profile building'
}, {
  label: 'Decision & Next-Best-Action',
  description: 'scoring, recommendations'
}, {
  label: 'Content & Communication',
  description: 'draft, translate, personalize, QA'
}, {
  label: 'Execution & Handoffs',
  description: 'tool calling, RPA/IPA integration'
}, {
  label: 'Assurance & Learning',
  description: 'feedback loops, guardrails, analytics'
}];
export function OutcomesSection() {
  return <section id="outcomes" className="py-24 bg-white" data-id="element-79">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-80">
        <h2 className="section-title" data-id="element-81">Drive Tangible Business Outcomes</h2>
        <p className="section-subtitle" data-id="element-82">
          Our goal is to move beyond experimentation and deliver measurable
          results by applying specific AI skills to your core processes.
        </p>
        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch" data-id="element-83">
          <div className="card flex flex-col h-full" data-id="element-84">
            <h3 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-85">
              Core Business Outcomes
            </h3>
            <p className="text-slate-600 mb-8" data-id="element-86">
              We focus on four key pillars of value. Each AI solution is
              designed to contribute to these outcomes.
            </p>
            <div className="flex-1 min-h-[320px]" data-id="element-87">
              <ResponsiveContainer width="100%" height="100%" data-id="element-88">
                <PieChart data-id="element-89">
                  <Pie data={chartData} cx="50%" cy="50%" innerRadius={80} outerRadius={120} paddingAngle={2} dataKey="value" data-id="element-90">
                    {chartData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-91" />)}
                  </Pie>
                  <Legend verticalAlign="bottom" height={36} iconType="circle" formatter={value => <span className="text-sm text-slate-700" data-id="element-93">{value}</span>} data-id="element-92" />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>
          <div className="card flex flex-col h-full" data-id="element-94">
            <h3 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-95">
              Process → AI Skills At-a-Glance
            </h3>
            <p className="text-slate-600 mb-6" data-id="element-96">
              We plug AI skills directly into your workflows (e.g., Lead →
              Order) to boost outcomes at every step:
            </p>
            <ul className="space-y-4 flex-1" data-id="element-97">
              {aiSkills.map(skill => <li key={skill.label} className="flex items-start gap-3" data-id="element-98">
                  <div className="flex-shrink-0 w-2 h-2 rounded-full bg-blue-600 mt-2" data-id="element-99"></div>
                  <div data-id="element-100">
                    <strong className="text-blue-600 block" data-id="element-101">
                      {skill.label}
                    </strong>
                    <span className="text-slate-600 text-sm" data-id="element-102">
                      {skill.description}
                    </span>
                  </div>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}